import React, { Component } from "react";
import axios from "axios";
import Image from "./Image";

const config = require("../config.json");

export default class ImagesAdmin extends Component {
  constructor(props) {
    super(props);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleBucketChange = this.handleBucketChange.bind(this);
  }

  state = {
    images: [],
    newImage: { id: "", data: "" },
    bucketName: config.s3.activityImagesBucket,
  };

  handleInputChange(event) {
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;

    this.setState({
      newImage: {
        ...this.state.newImage,
        [name]: value,
      },
    });
  }

  async handleBucketChange(event) {
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    await this.fetchImages(value);
    this.setState({
      bucketName: value,
    });
  }

  fetchImages = async (bucketName) => {
    try {
      const res = await axios.get(
        `${config.api.invokeUrl}/images?bucketName=${bucketName}`
      );
      if (res.data?.Contents) {
        const images = res.data.Contents;
        this.setState({ images });
      }
    } catch (err) {
      console.log(err);
    }
  };

  getBase64 = (file) => {
    return new Promise((resolve) => {
      let baseURL = "";
      // Make new FileReader
      let reader = new FileReader();
      // Convert the file to base64 text
      reader.readAsDataURL(file);
      // on reader load somthing...
      reader.onload = () => {
        // Make a fileInfo Object
        baseURL = reader.result;
        resolve(baseURL);
      };
    });
  };

  handleFileInputChange = (e) => {
    let file = e.target.files[0];
    this.getBase64(file)
      .then((result) => {
        file["base64"] = result;
        this.setState({
          newImage: { ...this.state.newImage, data: result },
        });
      })
      .catch((err) => {
        console.log(err);
      });
  };

  handleAddImage = async (event) => {
    event.preventDefault();
    try {
      const params = {
        data: this.state.newImage.data,
        bucketName: this.state.bucketName,
        id: this.state.newImage.id,
      };

      await axios.post(`${config.api.invokeUrl}/images`, params);
      this.fetchImages(this.state.bucketName);
      this.setState({
        newImage: { id: "", data: "" },
      });
    } catch (err) {
      console.log(err);
    }
  };

  handleDeleteImage = async (event, id) => {
    event.preventDefault();
    try {
      await axios.delete(
        `${config.api.invokeUrl}/images/${id}?bucketName=${this.state.bucketName}`
      );
      this.fetchImages(this.state.bucketName);
    } catch (err) {
      console.log(err);
    }
  };

  componentDidMount = () => {
    this.fetchImages(this.state.bucketName);
  };

  render() {
    return (
      <>
        <section className="section">
          <div className="container">
            <h1>Billeder Admin</h1>
            <p className="subtitle is-5">Tilføj og fjern billeder (KUN PNG)</p>
            <br />
            <div className="columns is-multiline">
              <div className="column is-full">
                <form onSubmit={(event) => this.handleAddImage(event)}>
                  <div className="field">
                    <div className="control">
                      <input
                        type={"text"}
                        name={"id"}
                        className="input is-medium mv-small"
                        placeholder="Billede navn/id"
                        onChange={this.handleInputChange}
                        value={this.state.newImage.id}
                      />

                      <input
                        name="data"
                        className="input is-medium"
                        type="file"
                        onChange={(e) => {
                          this.handleFileInputChange(e);
                        }}
                      />
                      <select
                        name="bucketName"
                        className="select is-medium"
                        onChange={this.handleBucketChange}
                        defaultValue={config.s3.activityImagesBucket}
                      >
                        <option value={config.s3.activityImagesBucket}>
                          Aktivitet
                        </option>
                        <option value={config.s3.organizationImagesBucket}>
                          Organisation
                        </option>
                        <option value={config.s3.notificationImagesBucket}>
                          Notifikationer
                        </option>
                        <option value={config.s3.campaignImagesBucket}>
                          Kampagne
                        </option>
                        <option value={config.s3.recipeImagesBucket}>
                          Opskrifter
                        </option>
                        <option value={config.s3.ingredientImagesBucket}>
                          Ingredienser
                        </option>
                      </select>
                    </div>
                    <div className="control">
                      <button
                        type="submit"
                        className="button is-primary is-medium"
                      >
                        Tilføj
                      </button>
                    </div>
                  </div>
                </form>
              </div>
              <div className="tile is-parent flex-wrap">
                {this.state.images.map((image, i) => (
                  <Image
                    key={i}
                    image={image}
                    bucketName={this.state.bucketName}
                    handleDeleteImage={this.handleDeleteImage}
                  />
                ))}
              </div>
            </div>
          </div>
        </section>
      </>
    );
  }
}
